import { createFileRoute } from "@tanstack/react-router";
import { AvbestillSelskapsAvtalePage } from "@/features/avtaler/components/avbestill/AvbestillSelskapsAvtalePage";

export const Route = createFileRoute(
  "/_app/avtaler/$avtalerId/selskap/avbestill/",
)({
  component: AvbestillSelskapsAvtalePage,
  head: () => ({
    meta: [
      {
        title: "Avbestill | Norgespris for Fjernvarme",
      },
    ],
  }),
});
